<template>
  <v-main>
    <v-alert id="alert" v-model="alertState.isAlert" :type="alertState.type" closable class="row" @click:close="alertState.reset()">{{ alertState.message }}</v-alert>
    <v-overlay :model-value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <h1>契約</h1>
      <div>
          ※利用終了日から7ヶ月以上経過したプロファイルは表示されません。
      </div>
    </v-container>
    <v-container v-for="(billing, key) in billingList" :key="key" fluid>
      <v-card name="billing">
        <v-card-title>
          <v-row>
            <v-col cols="12" sm="6" md="1">
              <v-text-field name="billingId" :model-value="billing.billing_id" label="契約ID" readonly density="compact" variant="underlined"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                name="billingName"
                :model-value="billing.billing_name"
                label="法人名"
                readonly
                density="compact"
                variant="underlined"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                name="billingSectionName"
                :model-value="billing.billing_section_name"
                label="部署"
                readonly
                density="compact"
                variant="underlined"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                name="billingRepresentativeName"
                :model-value="billing.billing_representative_name"
                label="担当者"
                readonly
                density="compact"
                variant="underlined"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" offset-md="8" class="mt-n8">
              <v-text-field
                v-model="billing.saerch"
                name="saerch"
                :append-inner-icon="mdiMagnify"
                label="絞り込み検索"
                variant="underlined"
                double-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table 
          v-model:page="billing.page"
          :headers="headers" 
          :items="billing.profile_list" 
          :items-per-page="billing.itemsPerPage" 
          :search="billing.saerch" 
          hide-default-footer
          class="elevation-1" 
          density="compact"
        >
          <template #item.profile_isnew="{ item }">
            <v-icon v-if="item.profile_isnew == 1" size="large" color="red" :icon="mdiNewBox"></v-icon>
          </template>
          <template #item.opening="{ item }">
            <v-btn
              name="billingProfileId"
              color="primary"
              size="small"
              variant="elevated"
              :to="{
                name: 'OpeningsList',
                params: {
                  billingProfileId: item.billing_profile_id,
                },
                query: {
                  profile_id: item.profile_id,
                },
              }"
              >表示
            </v-btn>
          </template>
          <template #bottom="props">
            <div class="text-center pt-2">
              <v-pagination
                v-model="billing.page"
                :length="props.pageCount"
              ></v-pagination>
              <v-text-field
                :model-value="props.itemsPerPage"
                class="pa-2"
                :label="perPageText"
                type="number"
                hide-details
                @update:model-value="onUpdateItemsPerPage($event, billing)"
              ></v-text-field>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import Pagination from '@/constants/pagination';
import { mdiMagnify, mdiNewBox } from '@mdi/js';
import { useAlertStore } from '../stores/alert';

export default {
  setup() {
    const alertState = useAlertStore();
    return {
      alertState,
    };
  },
  data: () => ({
    headers: [
      { title: '', key: 'profile_isnew', sortable: false, filterable: false, width: '2%' },
      { title: 'プロファイルID', key: 'profile_id', width: '23%' },
      { title: 'プロファイル名称', key: 'profile_name', width: '27%' },
      { title: '利用開始日', key: 'profile_start_date', filterable: false, width: '16%' },
      { title: '利用停止日', key: 'profile_end_date', filterable: false, width: '16%' },
      { title: '開通情報', key: 'opening', sortable: false, filterable: false, width: '16%' },
    ],
    billingList: [],
    sortBy: '',
    sortDesc: true,
    showOverlay: false,
    mdiMagnify,
    mdiNewBox,
  }),
  computed: {
    perPageText() {
      return Pagination.ITEMS_PER_PAGE_TEXT_WITH_NOTICE;
    },
  },
  unmounted() {
    this.alertState.reset();
  },
  created: async function () {
    this.showOverlay = true;
    try {
      await this.createBillingList();
    } finally {
      this.showOverlay = false;
    }
  },
  methods: {
    createBillingList: async function () {
      const accessToken = this.$cookies.get('access_token');
      console.log('accessToken=' + accessToken);

      let billinggroupId;
      let sessionResponse = await this.axios.get(Api.PATH_SESSION);
      console.log(sessionResponse);
      if (sessionResponse.data.status == Api.STATUS_SUCCESS) {
        billinggroupId = sessionResponse.data.session.billinggroup_id;
      } else {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }

      if (!billinggroupId) {
        console.log('billinggroupId is invalid.');
        return;
      }

      const isFirstLogin = sessionStorage.getItem('is_first_login') == "true" ? true : false;
      let billingResponse = await this.axios.get(Api.PATH_BILLING, {
        params: {
          billinggroup_id: billinggroupId,
          is_first_login: isFirstLogin,
        },
      });
      console.log(billingResponse);
      sessionStorage.removeItem('is_first_login')
      if (billingResponse.data.status == Api.STATUS_SUCCESS) {
        this.billingList = billingResponse.data.billing_list;
        billingResponse.data.isEmailTypeUnset;
        if (billingResponse.data.is_email_type_unset === 1) {
          alert("最初に連絡先を登録・更新してから、ご利用ください。");
        }
        console.log(this.billingList);
      } else {
        throw 'API_BILLINGS failed. status=' + billingResponse.data.status;
      }

      if (!this.billingList) {
        console.log('billingList is invalid.');
        return;
      }

      // 表示用の内容へ変更
      for (let i = 0; i < this.billingList.length; i++) {
        this.billingList[i].search = '';
        this.billingList[i].page = 1;
        this.billingList[i].itemsPerPage = 10;
      }
    },
    onUpdateItemsPerPage: function(event, billing) {
      let itemsPerPage = parseInt(event, 10);
      const oldItemsPerPage = billing.itemsPerPage;
      if (oldItemsPerPage < 0 || oldItemsPerPage >= 10000000) {
        return;
      }
      billing.itemsPerPage = itemsPerPage;
      if (itemsPerPage < 0 || itemsPerPage >= 10000000) {
        setTimeout(() => billing.itemsPerPage = oldItemsPerPage);
      }
    },
  },
};
</script>

<style scoped>
.container {
  width: 95%;
}
.v-overlay {
  align-items: center;
  justify-content: center;
}
.v-data-table :deep(th),
.v-data-table :deep(.v-data-table-footer) {
  font-size: 12px !important;
}
.v-data-table :deep(td) {
  font-size: 14px !important;
}
</style>
